import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  container: {
    padding: '1.5rem 0',
    textAlign: 'left',
  },
  titleStyle: {
    fontSize: '1.6rem',
    lineHeight: 1.5,
    fontWeight: 600,
    textTransform: 'uppercase',
    marginBottom: '0.6rem',
    color: theme.colors.primary,
  },
  listItemsStyle: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  imageIcon: {
    maxWidth: 130,
  },
  itemLinkStyle: {
    fontWeight: 400,
    display: 'block',
    marginRight: 0,
    lineHeight: 1,
    '&:hover a': {
      color: theme.colors.secondary,
    },
    '& a': {
      color: theme.colors.disabled,
      textDecoration: 'none',
      display: 'block',
      '&:before': {
        content: '"-"',
        marginRight: 5,
        display: 'inline',
      },
    },
  },
  itemLinkTemplateStyle: {
    fontWeight: 300,
    display: 'block',
    lineHeight: 1.25,
    '& a': {
      color: theme.colors.disabled,
      textDecoration: 'none',
    },
    '&:hover a': {
      color: theme.colors.secondary,
    },
    'html[lang^=zh] &': {
      fontSize: '1.4rem',
    },
  },
  itemLinkTagStyle: {
    display: 'inline',
    marginRight: 8,
    '& a': {
      display: 'inline',
      '&:before': {
        content: '"#"',
        marginRight: 0,
      },
    },
  },
  itemLinkInlineStyle: {
    display: 'inline-block',
    margin: '0 .8rem',
    fontSize: '1.4rem',
    fontWeight: 400,
    color: theme.colors.text,
    '&:hover a': {
      color: theme.colors.secondary,
    },
    '& a': {
      color: theme.colors.text,
      textDecoration: 'none',
    },
  },
  itemIconStyle: {
    display: 'inline-block',
    marginTop: '1rem',
    '& img': {
      width: '3rem',
      marginRight: '2rem',
    },
  },
  itemLinkIconStyle: {
    position: 'relative',
    display: 'block',
    width: 30,
    marginRight: 15,
  },
  icon: {
    position: 'absolute',
    left: 10,
    top: 10,
    transform: 'scale(2.3)',
    color: (
      theme.config.headerColorText
        ? theme.config.headerColorText
        : theme.colors.primary
    ),
  },
  itemButtonStyle: {
    marginLeft: 0,

    '&:hover a': {
      color: theme.colors.secondary,
    },
    '& a': {
      color: theme.colors.text,
      textDecoration: 'none',
      fontSize: 14,
      fontWeight: 600,
    },
    '& img': {
      margin: 0,
      marginLeft: 10,
    },
  },
  '@media (min-width: 1170px)': {
    itemButtonStyle: {
      marginLeft: -15,
    },
    container: {
      padding: '1.5rem 1.6rem',
    },
  },
}))

export default useStyles
